'use client';

import { Container } from "@mui/material";
import AboutStats from "@/components/ui/about/AboutStats";
import MissionSection from "@/components/ui/about/MissionSection";
import HistorySection from "@/components/ui/about/HistorySection";
import OfficeLocations from "@/components/ui/about/OfficeLocations";
import WelcomeSection from "@/components/ui/about/WelcomeSection";
import BoardSection from "@/components/ui/about/BoardSection";

export default function AboutContent() {
    return (
        <main className="flex flex-col min-h-screen bg-[#f8fafc]">
            <WelcomeSection />
            <Container sx={{ margin: "auto", maxWidth: "lg" }}>
                <AboutStats />
                <MissionSection />
                <HistorySection />
                <OfficeLocations />
                <BoardSection />
            </Container>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "AboutPage",
                        "name": "運営会社・SpaciaNetについて | AirXpress EX",
                        "url": "https://airxpress.jp/about",
                        "mainEntity": {
                            "@type": "Organization",
                            "name": "SpaciaNet Japan株式会社",
                            "url": "https://airxpress.jp",
                            "logo": "https://airxpress.jp/images/og-logo-color.webp",
                            "sameAs": [
                                "https://www.facebook.com/spacianet.co.jp/",
                                "https://www.instagram.com/spacianet__airxpress",
                                "https://x.com/nairxpress",
                                "https://www.tiktok.com/@spacianet__airxpress"
                            ],
                            "contactPoint": {
                                "@type": "ContactPoint",
                                "telephone": "+81-6-6123-1071",
                                "contactType": "customer service",
                                "areaServed": "JP",
                                "availableLanguage": ["Japanese", "English", "Chinese", "Korean"]
                            }
                        }
                    })
                }}
            />

        </main>
    );
}
